module.exports = __webpack_public_path__ + "img/act_code1.ad1b64a5.png";